module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iNDgiPjxwYXRoIGQ9Ik00MjAtODB2LTIyMEgzMDBsMTAyLTMyOHE4LTI1IDMwLTM4LjV0NDgtMTMuNXEyNiAwIDQ4IDEzLjV0MzAgMzguNWwxMDIgMzI4SDU0MHYyMjBINDIwWm02MC4wOC02NTRxLTMwLjA4IDAtNTEuNTgtMjEuNDItMjEuNS0yMS40MjEtMjEuNS01MS41IDAtMzAuMDggMjEuNDItNTEuNTggMjEuNDIxLTIxLjUgNTEuNS0yMS41IDMwLjA4IDAgNTEuNTggMjEuNDIgMjEuNSAyMS40MjEgMjEuNSA1MS41IDAgMzAuMDgtMjEuNDIgNTEuNTgtMjEuNDIxIDIxLjUtNTEuNSAyMS41WiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/woman.svg
// module id = qsGU
// module chunks = 0